export default __webpack_public_path__ + "static/media/celcoin.c610ede5.png";